/*
 * Generated by tutor-mfe for all.
 *
 * Frontend-base counterpart of the legacy env.config.jsx.
 */


import React, { useEffect } from 'react';

import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient as getUrfuHttpClient, getAuthenticatedUser as getUrfuAuthenticatedUser } from '@edx/frontend-platform/auth';
import { useIntl as useIndigoIntl } from '@edx/frontend-platform/i18n';
import { Avatar, Icon } from '@openedx/paragon';
import { ExpandMore, Nightlight, Person, WbSunny } from '@openedx/paragon/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



import { useRef, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getAuthenticatedHttpClient, getAuthenticatedUser, getHttpClient } from '@edx/frontend-platform/auth';
import { useLocation } from "react-router-dom";
import { Card, Hyperlink, Spinner, Alert, Form } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';
import { defineMessages } from '@edx/frontend-platform/i18n';

import { DIRECT_PLUGIN, IFRAME_PLUGIN, PLUGIN_OPERATIONS } from '@openedx/frontend-plugin-framework';

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }
  config.pluginSlots[slot_name].plugins.push(...plugins);
}
let themeVariant = 'selected-paragon-theme-variant';

const URFU_BRAND_CSS = `
  html {
    font-size: 90%;
  }
  :root, html[data-paragon-theme-variant="light"] {
    --pgn-color-primary: #15376D;
    --pgn-color-primary-100: #EEF3FA;
    --pgn-color-primary-200: #C5D4EB;
    --pgn-color-primary-300: #7A9BC7;
    --pgn-color-primary-400: #3D5F94;
    --pgn-color-primary-500: #15376D;
    --pgn-color-primary-700: #0F2A57;
    --pgn-color-brand: #15376D;
    --pgn-color-info-500: #15376D;
    --pgn-color-accent-a: #15376D;
    --pgn-color-white: #ffffff;
    --pgn-color-bg: #ffffff;
    --pgn-color-body-bg: #ffffff;
    --pgn-corner-radius-sm: 8px;
    --pgn-corner-radius-md: 8px;
    --pgn-corner-radius-lg: 12px;
  }
  .home-banner {
    overflow: visible !important;
  }
  .home-banner::before {
    z-index: -1;
  }
  .home-banner .animation-wrapper {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
    position: relative;
    z-index: 1;
  }
  header a[href*="/register"],
  header a[href*="authn/register"],
  header .register-btn {
    display: none !important;
  }
  header.site-header-desktop .container-fluid,
  header.site-header-desktop .secondary-menu-container {
    gap: 12px;
  }
  header a.urfu-themed-logo,
  header .logo,
  header .pgn__header-logo {
    margin-right: 1.5rem !important;
  }
  header nav[aria-label="Основная навигация"],
  header nav[aria-label="Main"],
  header nav[aria-label="Main navigation"] {
    margin-left: 0.5rem;
  }
  #root header.site-header-desktop .main-nav,
  header.site-header-desktop .main-nav {
    display: flex !important;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.25rem;
  }
  #root header.site-header-desktop .main-nav a.nav-link,
  header.site-header-desktop .main-nav a.nav-link {
    margin: 0 !important;
  }
  .pgn__searchfield {
    border: 1px solid #e5e7eb !important;
    border-radius: 10px !important;
    background: #f4f7fb !important;
    overflow: hidden;
    min-height: 40px;
    box-shadow: none !important;
  }
  .pgn__searchfield::after,
  .pgn__searchfield:hover::after,
  .pgn__searchfield.has-focus::after,
  .pgn__searchfield_wrapper::after,
  .pgn__searchfield-wrapper::after,
  .pgn__searchfield--external.has-focus .pgn__searchfield_wrapper::after {
    content: none !important;
    display: none !important;
    border: 0 !important;
    box-shadow: none !important;
  }
  .pgn__searchfield_wrapper,
  .pgn__searchfield-wrapper,
  .pgn__searchfield_wrapper:hover,
  .pgn__searchfield_wrapper:active,
  .pgn__searchfield-wrapper:hover,
  .pgn__searchfield:hover,
  .pgn__searchfield:active {
    border: none !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }
  .home-banner .container-mw-sm.container-fluid,
  .home-banner .container-mw-sm,
  .home-banner .container-fluid,
  .urfu-home-overlay-root + .container-mw-sm,
  .urfu-home-overlay-root + .container-fluid {
    max-width: min(1120px, calc(100% - 2rem)) !important;
    width: 100% !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .pgn__searchfield form,
  .pgn__searchfield-form {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }
  .pgn__searchfield .form-control {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .pgn__searchfield:focus-within {
    border-color: #15376d !important;
    box-shadow: 0 0 0 3px rgba(21, 55, 109, 0.12) !important;
    border-radius: 10px !important;
  }
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield,
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield:focus-within,
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield.has-focus,
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield .form-control,
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield .form-control:focus {
    border-radius: 10px !important;
  }
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield--external,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield:focus-within,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield.has-focus,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield--external:focus-within,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield--external.has-focus,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield .form-control:focus {
    border-radius: 14px !important;
  }
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield.has-focus::after,
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield:focus-within::after,
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield--external.has-focus .pgn__searchfield_wrapper::after {
    content: none !important;
    display: none !important;
  }
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield .form-control:focus {
    outline: none !important;
    box-shadow: none !important;
  }
  .home-banner .pgn__searchfield--external {
    background: #fff !important;
    border: none !important;
    border-radius: 14px !important;
    box-shadow: 0 12px 32px rgba(11, 28, 56, 0.28) !important;
    min-height: 52px;
    align-items: center;
    padding: 4px 4px 4px 8px;
    max-width: 100% !important;
    width: 100% !important;
  }
  .home-banner .pgn__searchfield--external .pgn__searchfield__button,
  .pgn__searchfield__button.btn-primary {
    border: none !important;
    box-shadow: none !important;
    min-width: 44px !important;
    width: 44px !important;
    height: 44px !important;
    padding: 0 !important;
    margin: 0 2px 0 0;
    border-radius: 10px !important;
    font-size: 0 !important;
    line-height: 0 !important;
    color: transparent !important;
    text-indent: 0 !important;
    overflow: hidden;
    background-color: #15376D !important;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z'/%3E%3C/svg%3E") !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 20px 20px !important;
  }
  .pgn__searchfield__button.btn-primary > * {
    display: none !important;
  }
  .home-banner .pgn__searchfield.w-25 { width: min(100%, 28rem) !important; }
  .container .pgn__searchfield,
  .container .pgn__searchfield.w-25,
  .container-mw-xl .pgn__searchfield,
  .container-mw-xl .pgn__searchfield.w-25,
  .pgn__page .pgn__searchfield,
  .pgn__page .pgn__searchfield.w-25 {
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 1rem;
    box-sizing: border-box;
  }
  .home-banner .pgn__searchfield.w-25,
  .home-banner .pgn__searchfield,
  .home-banner .pgn__searchfield--external,
  .home-banner .pgn__form-group {
    width: 100% !important;
    max-width: 100% !important;
  }
  .urfu-home-overlay-root {
    width: min(1120px, calc(100% - 2rem)) !important;
    max-width: min(1120px, calc(100% - 2rem)) !important;
    margin-left: auto !important;
    margin-right: auto !important;
    box-sizing: border-box;
  }
  .urfu-card-end {
    font-size: 13px;
    color: #6b7280;
    margin-top: 0;
    padding: 0 1rem 0.85rem;
  }
  .urfu-catalog-course-card {
    display: flex;
    flex-direction: column;
    width: 100% !important;
    max-width: 100% !important;
    height: auto;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(21, 55, 109, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
  }
  .urfu-catalog-course-card .pgn__card-header {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 0.35rem;
  }
  .urfu-catalog-course-card .pgn__card-header-subtitle {
    margin-left: 0 !important;
    width: 100% !important;
  }
  .urfu-catalog-course-card .pgn__card-footer,
  .urfu-catalog-course-card__meta {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 0.15rem;
    white-space: normal;
  }
  .urfu-catalog-course-card .pgn__card-footer-text {
    white-space: normal !important;
  }
  .urfu-catalog-course-card .pgn__card,
  .urfu-catalog-course-card .course-card {
    flex: 1 1 auto;
    box-shadow: none !important;
    border: none !important;
    margin-bottom: 0 !important;
    height: auto !important;
    max-width: 100%;
  }
  html[data-paragon-theme-variant="dark"] #root .urfu-catalog-course-card {
    background: #292A2C;
    box-shadow: none;
    border: 1px solid #777792;
  }
  html[data-paragon-theme-variant="dark"] #root .urfu-catalog-course-card .pgn__card-header {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    position: relative !important;
    gap: 0.35rem;
  }
  html[data-paragon-theme-variant="dark"] #root .urfu-catalog-course-card .pgn__card-header-title,
  html[data-paragon-theme-variant="dark"] #root .urfu-catalog-course-card .pgn__card-header-subtitle {
    position: static !important;
    inset: auto !important;
    float: none !important;
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
  }
  html[data-paragon-theme-variant="dark"] #root .urfu-catalog-course-card .pgn__card,
  html[data-paragon-theme-variant="dark"] #root .urfu-catalog-course-card .course-card {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }
  .urfu-catalog-layout {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    width: 100%;
  }
  .urfu-catalog-sidebar {
    width: 100%;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 1rem;
  }
  .urfu-catalog-sidebar__title {
    margin: 0;
    font-size: 1.05rem;
    font-weight: 700;
    color: #15376D;
  }
  .urfu-catalog-sidebar__hint {
    margin: 0.25rem 0 0.85rem;
    font-size: 13px;
    color: #6b7280;
  }
  .urfu-catalog-filters {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .urfu-catalog-filters button {
    width: 100%;
    text-align: left;
    border: 1px solid #e5e7eb;
    background: #f4f7fb;
    color: #15376D;
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }
  .urfu-catalog-filters button.is-active {
    background: #15376D;
    border-color: #15376D;
    color: #fff;
  }
  .urfu-catalog-result-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    text-decoration: none;
    color: inherit;
    box-shadow: 0 1px 3px rgba(21, 55, 109, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
  }
  .urfu-catalog-result-card__title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 700;
    color: #111827;
  }
  .urfu-catalog-result-card__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: auto;
    padding-top: 0.85rem;
  }
  .urfu-catalog-result-card__about {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    border-radius: 10px;
    background: #15376D;
    color: #fff !important;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none !important;
  }
  .urfu-catalog-result-card__learn {
    flex: 0 0 42px;
    width: 42px;
    height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: #fff;
    color: #15376D;
    text-decoration: none;
  }
  html[data-paragon-theme-variant="dark"] .urfu-catalog-sidebar,
  html[data-paragon-theme-variant="dark"] .urfu-catalog-result-card {
    background: #292A2C;
    border: 1px solid #777792;
    box-shadow: none;
  }
  html[data-paragon-theme-variant="dark"] .urfu-catalog-result-card__title {
    color: #F9FAFB;
  }
  html[data-paragon-theme-variant="dark"] .urfu-catalog-result-card__pills span {
    background: #1f2023;
    color: #C5D4EB;
  }
  html[data-paragon-theme-variant="dark"] .urfu-catalog-result-card__learn {
    background: #1f2023;
    border-color: #777792;
    color: #C5D4EB;
  }
  html[data-paragon-theme-variant="dark"] .urfu-catalog-filters button {
    background: #1f2023;
    border-color: #777792;
  }
  html[data-paragon-theme-variant="dark"] .urfu-catalog-filters button.is-active {
    background: #15376D;
    border-color: #15376D;
    color: #fff;
  }
  html[data-paragon-theme-variant="dark"] .urfu-catalog-result-card__org {
    background: #1f2023;
    color: #C5D4EB;
  }
  @media (min-width: 768px) {
    .urfu-catalog-layout {
      flex-direction: row;
      align-items: flex-start;
      gap: 2rem;
    }
    .urfu-catalog-sidebar {
      flex: 0 0 240px;
    }
    .urfu-catalog-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, 260px);
      justify-content: start;
      gap: 1.25rem;
    }
    .urfu-catalog-course-card {
      width: 260px !important;
      max-width: 260px !important;
    }
  }
  footer.tutor-container .nav-colophon ol,
  .urfu-indigo-footer .nav-colophon ol {
    text-align: center !important;
  }
  @media (min-width: 992px) {
    header.site-header-mobile { display: none !important; }
    button.urfu-theme-toggle-mobile { display: none !important; }
  }
  @media (max-width: 991.98px) {
    header.site-header-desktop { display: none !important; }
    button.urfu-theme-toggle-desktop { display: none !important; }
    header.site-header-mobile {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
    header.site-header-mobile .logo-holder {
      min-width: 0;
      flex: 1 1 auto;
    }
    header.site-header-mobile {
      position: relative !important;
      overflow: visible !important;
      z-index: 1030;
    }
    html body #root button.urfu-theme-toggle-mobile {
      position: fixed !important;
      top: 3px !important;
      right: 72px !important;
      left: auto !important;
      z-index: 1040;
      width: 36px !important;
      height: 36px !important;
      margin: 0 10px 0 0 !important;
    }
    html #root header.site-header-mobile .menu .menu-content,
    html #root header.site-header-mobile .menu.expanded .menu-content {
      position: absolute !important;
      top: 100% !important;
      left: 0 !important;
      right: 0 !important;
      bottom: auto !important;
      width: 100% !important;
      margin: 0 !important;
      transform: none !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      max-height: min(70vh, 480px);
      z-index: 1045;
    }
    html #root header.site-header-mobile .menu .menu-content .nav-item {
      position: relative !important;
      transform: none !important;
      width: 100% !important;
      float: none !important;
    }
  }
  header img.logo:not([src*="white"]),
  header .logo img:not([src*="white"]),
  a.urfu-themed-logo img:not([src*="white"]),
  .footer-icon:not([src*="white"]),
  img[src*="UrFULogo"] {
    filter: brightness(0) saturate(100%) invert(16%) sepia(48%) saturate(1650%) hue-rotate(196deg) brightness(92%) contrast(95%);
  }
  html[data-paragon-theme-variant="dark"] header.site-header-desktop,
  html[data-paragon-theme-variant="dark"] header.site-header-mobile,
  html[data-paragon-theme-variant="dark"] header.site-header-desktop .nav-container {
    background-color: #1e1e1e !important;
    color: #F8F8F8 !important;
  }
  html[data-paragon-theme-variant="dark"] header a,
  html[data-paragon-theme-variant="dark"] header .nav-link,
  html[data-paragon-theme-variant="dark"] header .btn,
  html[data-paragon-theme-variant="dark"] header .btn-outline-primary {
    color: #AEC7F6 !important;
  }
  html[data-paragon-theme-variant="dark"] button.urfu-theme-toggle {
    background: #112F6B !important;
    border-color: rgba(174, 199, 246, 0.35) !important;
    color: #AEC7F6 !important;
  }
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield--external,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield_wrapper,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield form,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield .form-control {
    background: #36383B !important;
    background-color: #36383B !important;
  }
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield--external,
  html[data-paragon-theme-variant="dark"] #root .home-banner .pgn__searchfield {
    border: 1px solid #777792 !important;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45) !important;
    min-height: 52px !important;
  }
  html[data-paragon-theme-variant="dark"] header img.logo:not([src*="white"]),
  html[data-paragon-theme-variant="dark"] a.urfu-themed-logo img:not([src*="white"]),
  html[data-paragon-theme-variant="dark"] .footer-icon:not([src*="white"]),
  html[data-paragon-theme-variant="dark"] img[src*="UrFULogo"] {
    filter: brightness(0) invert(1);
  }
  html[data-paragon-theme-variant="light"],
  html[data-paragon-theme-variant="light"] body,
  html[data-paragon-theme-variant="light"] #root {
    background-color: #ffffff;
    color: #111827;
  }
  html[data-paragon-theme-variant="dark"] {
    --pgn-color-primary: #AEC7F6;
    --pgn-color-primary-500: #AEC7F6;
    --pgn-color-primary-700: #EEF3FA;
    --pgn-color-brand: #AEC7F6;
    --pgn-color-info-500: #AEC7F6;
    --pgn-color-bg: #1e1e1e;
    --pgn-color-body-bg: #1e1e1e;
    --pgn-color-text-base: #F8F8F8;
    --pgn-color-gray-100: #292A2C;
    --pgn-color-gray-200: #36383B;
  }
  html[data-paragon-theme-variant="dark"],
  html[data-paragon-theme-variant="dark"] body,
  html[data-paragon-theme-variant="dark"] #root,
  html[data-paragon-theme-variant="dark"] .pgn__page {
    background-color: #1e1e1e !important;
    color: #F8F8F8;
  }
  html[data-paragon-theme-variant="dark"] .pgn__card,
  html[data-paragon-theme-variant="dark"] .pgn__card-light,
  html[data-paragon-theme-variant="dark"] .card,
  html[data-paragon-theme-variant="dark"] .bg-white,
  html[data-paragon-theme-variant="dark"] .bg-light,
  html[data-paragon-theme-variant="dark"] .pgn__menu,
  html[data-paragon-theme-variant="dark"] .pgn__modal-body,
  html[data-paragon-theme-variant="dark"] .course-card {
    background-color: #292A2C !important;
    color: #F8F8F8 !important;
    border-color: #777792 !important;
  }
  html[data-paragon-theme-variant="dark"] .pgn__card-header-title,
  html[data-paragon-theme-variant="dark"] .pgn__card-header-title-sm,
  html[data-paragon-theme-variant="dark"] .pgn__card-header-title-md,
  html[data-paragon-theme-variant="dark"] h1,
  html[data-paragon-theme-variant="dark"] h2,
  html[data-paragon-theme-variant="dark"] h3,
  html[data-paragon-theme-variant="dark"] h4,
  html[data-paragon-theme-variant="dark"] p,
  html[data-paragon-theme-variant="dark"] .pgn__card-header-subtitle-sm,
  html[data-paragon-theme-variant="dark"] .pgn__card-footer-text {
    color: #F8F8F8 !important;
  }
  html[data-paragon-theme-variant="dark"] header.site-header-desktop,
  html[data-paragon-theme-variant="dark"] header.border-bottom {
    background-color: #1e1e1e !important;
    border-color: #777792 !important;
  }
  html[data-paragon-theme-variant="dark"] .urfu-indigo-footer.wrapper-footer {
    background: #1e1e1e !important;
    border-top-color: #777792 !important;
    color: #F8F8F8 !important;
  }
  html[data-paragon-theme-variant="dark"] .pgn__modal,
  html[data-paragon-theme-variant="dark"] .pgn__dropdown-menu,
  html[data-paragon-theme-variant="dark"] .dropdown-menu,
  html[data-paragon-theme-variant="dark"] #root .form-control,
  html[data-paragon-theme-variant="dark"] select.form-control-sm,
  html[data-paragon-theme-variant="dark"] .pgn__form-control {
    background-color: #36383B !important;
    color: #F8F8F8 !important;
    -webkit-text-fill-color: #F8F8F8 !important;
    border-color: #777792 !important;
    caret-color: #F8F8F8;
  }
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield {
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    background: #36383B !important;
    border-color: #777792 !important;
  }
  html[data-paragon-theme-variant="dark"] #root .pgn__page .pgn__searchfield .form-control,
  html[data-paragon-theme-variant="dark"] #root .pgn__page .pgn__searchfield input {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: #F8F8F8 !important;
    -webkit-text-fill-color: #F8F8F8 !important;
    caret-color: #F8F8F8;
    flex: 1 1 auto !important;
    width: auto !important;
    min-width: 0 !important;
  }
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield .form-control::placeholder,
  html[data-paragon-theme-variant="dark"] #root .pgn__searchfield input::placeholder {
    color: #9CA3AF !important;
    -webkit-text-fill-color: #9CA3AF !important;
    opacity: 1;
  }
  html[data-paragon-theme-variant="dark"] .text-neutral-regular,
  html[data-paragon-theme-variant="dark"] .text-muted {
    color: #DDDFE2 !important;
  }
  header .secondary-menu-container button.urfu-theme-toggle-desktop ~ button.urfu-theme-toggle-desktop {
    display: none !important;
  }
  html[data-paragon-theme-variant="dark"] .home-banner,
  html[data-paragon-theme-variant="dark"] .home-banner.bg-light,
  html[data-paragon-theme-variant="dark"] .home-banner.bg-white {
    background-color: transparent !important;
  }
  html[data-paragon-theme-variant="dark"] #root {
    overflow-x: visible !important;
  }
  @media (min-width: 992px) {
    html[data-paragon-theme-variant="dark"] #root .user-dropdown {
      position: relative !important;
      overflow: visible !important;
    }
    html[data-paragon-theme-variant="dark"] #root .user-dropdown .dropdown-menu,
    html[data-paragon-theme-variant="dark"] #root header.site-header-desktop .menu .menu-content {
      position: absolute !important;
      top: 100% !important;
      right: 0 !important;
      left: auto !important;
      bottom: auto !important;
      transform: none !important;
      margin: 6px 0 0 !important;
      width: 224px !important;
      z-index: 1050 !important;
    }
  }
  html, body, #root {
    font-family: Inter, "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
`;

const AddDarkTheme = () => {
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  useEffect(() => {
    const theme = window.localStorage.getItem(themeVariant)
      || window.localStorage.getItem('theme');
    if (document.body) {
      document.body.classList.toggle('indigo-dark-theme', isThemeToggleEnabled && theme === 'dark');
    }
    if (theme === 'light' || theme === 'dark') {
      document.documentElement.setAttribute('data-paragon-theme-variant', theme);
      document.documentElement.setAttribute('data-theme-variant', theme);
    }
  }, [isThemeToggleEnabled]);

  return <style>{URFU_BRAND_CSS}</style>;
};



function setConfig() {
  const config = {
    pluginSlots: {},
  };// Inside setConfig so this does not collide with module-level imports.
// ProctorX widgets call useIntl / useState; webpack merges
// `import { useIntl }` into indigo's `useIntl as useIndigoIntl` and drops the binding.
const useIntl = useIndigoIntl;
const useState = React.useState;
const IndigoFooter = () => {
  const intl = useIndigoIntl();
  const config = getConfig();
  const lmsBaseUrl = config.LMS_BASE_URL;
  const indigoFooterNavLinks = config.INDIGO_FOOTER_NAV_LINKS || [];

  const urfuLogoUrl = 'https://openedu.urfu.ru/files/courses_catalog/UrFULogo1.svg';
  const mainSupportEmail = 'openedu@urfu.ru';
  const techSupportEmail = 'courses.openedu@urfu.ru';
  const locale = (intl.locale || 'ru').toLowerCase().split('-')[0];

  const copy = {
    en: {
      usefulLinks: 'Useful links',
      supportTitle: 'UrFU student support',
      techSupportTitle: 'Technical support',
      orgLine1: 'Ural Federal University named after the first President of Russia B. N. Yeltsin',
      orgLine2: 'Center for New Educational Technologies and Audiovisual Learning Tools',
      address: 'Yekaterinburg, Mira St. 19, office I-200',
      copyright: `Copyrights ©${new Date().getFullYear()}. All Rights Reserved.`,
      languageLabel: 'Choose Language',
      languageApply: 'Apply',
    },
    ru: {
      usefulLinks: 'Полезные ссылки',
      supportTitle: 'Поддержка студентов УрФУ',
      techSupportTitle: 'Техническое сопровождение',
      orgLine1: 'ФГАОУ ВО «УрФУ имени первого Президента России Б.Н.Ельцина»',
      orgLine2: 'Центр новых образовательных технологий и аудиовизуальных средств обучения',
      address: 'Екатеринбург, ул. Мира д.19, каб. И-200',
      copyright: `© ${new Date().getFullYear()}. Все права защищены.`,
      languageLabel: 'Выберите язык',
      languageApply: 'Применить',
    },
  };
  const t = copy[locale] || copy.ru;

  const externalLinkClickHandler = (event) => {
    event.currentTarget.getAttribute('href');
  };

  const supportedLanguages = [
    { label: 'English', value: 'en' },
    { label: 'Русский', value: 'ru' },
    { label: '中文 (简体)', value: 'zh-cn' },
    { label: 'العربية', value: 'ar' },
  ];

  const handleLanguageSelected = (languageCode) => {
    document.cookie = `openedx-language-preference=${languageCode}; path=/; max-age=31536000`;
    window.location.reload();
  };

  const handleLanguageSubmit = (e) => {
    e.preventDefault();
    const languageCode = e.target.elements['site-footer-language-select'].value;
    handleLanguageSelected(languageCode);
  };

  const renderNavLinks = () => {
    if (!indigoFooterNavLinks?.length) return null;
    return (
      <nav className="nav-colophon" aria-label={t.usefulLinks}>
        <ol>
          {indigoFooterNavLinks.map((link) => (
            <li key={link.url}>
              <a
                href={link.url.startsWith('http') ? link.url : `${lmsBaseUrl}${link.url}`}
                onClick={externalLinkClickHandler}
              >
                {link.title}
              </a>
            </li>
          ))}
        </ol>
      </nav>
    );
  };

  return (
    <div className="wrapper wrapper-footer urfu-indigo-footer">
      <style>
        {`
          .urfu-indigo-footer.wrapper-footer {
            background: #fff;
            border-top: 1px solid #e5e7eb;
            padding: 2rem 0;
            font-size: 0.9rem;
            color: #1f2937;
          }
          .urfu-indigo-footer .tutor-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 1rem;
          }
          .urfu-indigo-footer .footer-top { margin-bottom: 2rem; }
          .urfu-indigo-footer .footer-cols {
            display: flex;
            flex-wrap: wrap;
            gap: 1.5rem;
            align-items: flex-start;
            justify-content: space-between;
          }
          .urfu-indigo-footer .footer-col {
            flex: 1 1 220px;
            min-width: 220px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
          .urfu-indigo-footer .col-title {
            font-weight: 700;
            text-transform: uppercase;
            margin-bottom: 1rem;
            font-size: 0.85rem;
            letter-spacing: 0.05em;
            color: #15376D;
          }
          .urfu-indigo-footer .logo-list {
            margin-bottom: 0.75rem;
            display: flex;
            justify-content: center;
          }
          .urfu-indigo-footer .footer-icon {
            height: 40px;
            width: auto;
            object-fit: contain;
            filter: brightness(0) saturate(100%) invert(16%) sepia(48%) saturate(1650%) hue-rotate(196deg) brightness(92%) contrast(95%);
          }
          .urfu-indigo-footer .nav-colophon ol {
            list-style: none;
            padding: 0;
            margin: 0;
            text-align: center;
          }
          .urfu-indigo-footer .nav-colophon li { margin: 0.5rem 0; }
          .urfu-indigo-footer .nav-colophon a {
            color: #15376D;
            text-decoration: none;
            font-weight: 500;
          }
          .urfu-indigo-footer .nav-colophon a:focus-visible {
            outline: 2px solid #15376D;
            outline-offset: 2px;
          }
          .urfu-indigo-footer .footer-org-text {
            color: #6b7280;
            line-height: 1.4;
            font-size: 0.85rem;
          }
          .urfu-indigo-footer .footer-support-email {
            font-size: 1rem;
            font-weight: 600;
            margin-bottom: 1rem;
          }
          .urfu-indigo-footer .footer-support-email a {
            color: #15376D;
            text-decoration: none;
          }
          .urfu-indigo-footer .footer-tech-support {
            font-size: 0.85rem;
            color: #6b7280;
            line-height: 1.4;
          }
          .urfu-indigo-footer .footer-tech-support .tech-title {
            font-weight: 700;
            color: #15376D;
            margin-bottom: 4px;
          }
          .urfu-indigo-footer .colophon {
            margin-top: 2rem;
            padding-top: 1.5rem;
            border-top: 1px solid #f3f4f6;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
          }
          .urfu-indigo-footer .copyright-site {
            color: #9ca3af;
            font-size: 0.8rem;
          }
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer.wrapper-footer {
            background: #1e1e1e;
            border-top-color: #777792;
            color: #F8F8F8;
          }
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer .col-title,
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer .nav-colophon a,
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer .footer-support-email a,
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer .footer-tech-support .tech-title {
            color: #AEC7F6;
          }
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer .footer-org-text,
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer .footer-tech-support,
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer .copyright-site {
            color: #DDDFE2;
          }
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer .colophon {
            border-top-color: #777792;
          }
          html[data-paragon-theme-variant="dark"] .urfu-indigo-footer .footer-icon {
            filter: brightness(0) invert(1);
          }
          @media (max-width: 768px) {
            .urfu-indigo-footer .footer-cols {
              flex-direction: column;
              align-items: center;
            }
            .urfu-indigo-footer .footer-col {
              width: 100%;
              margin-bottom: 1.5rem;
            }
          }
        `}
      </style>
      <footer id="footer" className="tutor-container">
        <div className="footer-top">
          <div className="footer-cols">
            <div className="footer-col">
              <div className="logo-list" aria-hidden="true">
                <img src={urfuLogoUrl} alt="UrFU Logo" className="footer-icon" />
              </div>
              <p className="footer-org-text">
                {t.orgLine1}
                <br />
                {t.orgLine2}
              </p>
            </div>

            <div className="footer-col">
              <div className="col-title">{t.usefulLinks}</div>
              {renderNavLinks()}
            </div>

            <div className="footer-col">
              <div className="col-title">{t.supportTitle}</div>
              <div className="footer-support-email">
                <a href={`mailto:${mainSupportEmail}`} onClick={externalLinkClickHandler}>
                  {mainSupportEmail}
                </a>
              </div>
              <div className="footer-tech-support">
                <div className="tech-title">{t.techSupportTitle}</div>
                <div className="text-neutral-regular">
                  {t.address}
                  <br />
                  <a href={`mailto:${techSupportEmail}`} onClick={externalLinkClickHandler}>
                    {techSupportEmail}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="colophon">
          <form className="form-inline" onSubmit={handleLanguageSubmit}>
            <div className="form-group">
              <label htmlFor="site-footer-language-select" className="d-inline-block m-0">
                {t.languageLabel}
              </label>
              <select
                id="site-footer-language-select"
                className="form-control-sm mx-2"
                name="site-footer-language-select"
                defaultValue={intl.locale}
              >
                {supportedLanguages.map(({ value, label }) => (
                  <option key={value} value={value}>{label}</option>
                ))}
              </select>
              <button data-testid="site-footer-submit-btn" className="btn btn-outline-primary btn-sm" type="submit">
                {t.languageApply}
              </button>
            </div>
          </form>
          <div className="copyright-site">{t.copyright}</div>
        </div>
      </footer>
    </div>
  );
};


const UrfuHomeOverlay = () => {
  const config = getConfig();
  const siteName = config.SITE_NAME || config.PLATFORM_NAME || 'УрФУ';
  const welcome = config.INDIGO_WELCOME_MESSAGE || '';
  const lmsBase = String(config.LMS_BASE_URL || '').replace(/\/$/, '');
  const coverUrl = `${lmsBase}/theming/asset/images/urfu-home-cover.jpg`;

  return (
    <div className="urfu-home-overlay-root">
      <style>
        {`
          html {
            --catalog-home-page-banner-background-image:
              linear-gradient(rgba(11, 28, 56, 0.62), rgba(21, 55, 109, 0.55)),
              url("${coverUrl}");
            --catalog-home-page-banner-background-color: #0F2A57;
          }
          .urfu-home-overlay-root {
            width: min(1120px, calc(100% - 2rem));
            max-width: min(1120px, calc(100% - 2rem));
            margin-left: auto;
            margin-right: auto;
            color: inherit;
            box-sizing: border-box;
          }
          .home-banner .container-mw-sm.container-fluid,
          .home-banner .container-mw-sm,
          .home-banner .container-fluid,
          .urfu-home-overlay-root + .container-mw-sm,
          .urfu-home-overlay-root + .container-fluid {
            max-width: min(1120px, calc(100% - 2rem)) !important;
            width: 100% !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
            margin-left: auto !important;
            margin-right: auto !important;
            box-sizing: border-box;
          }
          .home-banner {
            overflow: visible !important;
          }
          .home-banner::before {
            z-index: -1;
          }
          .home-banner .animation-wrapper {
            animation: none !important;
            opacity: 1 !important;
            transform: none !important;
            position: relative;
            z-index: 1;
          }
          .urfu-home-overlay-root .heading-overlay h1 {
            font-size: 22px;
            font-weight: 800;
            line-height: 28px;
            color: #fff;
            margin: 0 0 8px;
            letter-spacing: -0.01em;
          }
          .urfu-home-overlay-root .heading-overlay p {
            font-size: 15px;
            line-height: 22px;
            color: rgba(255, 255, 255, 0.92);
            margin: 0;
          }
          @media (min-width: 768px) {
            .urfu-home-overlay-root .heading-overlay h1 {
              font-size: 28px;
              line-height: 34px;
            }
          }
        `}
      </style>
      <div className="heading-overlay">
        <h1>{siteName}</h1>
        {welcome ? <p>{welcome}</p> : null}
      </div>
    </div>
  );
};


const UrfuHomeBanners = () => {
  const intl = useIndigoIntl();
  const config = getConfig();
  const fallbackLinks = config.URFU_HOME_INFO_LINKS || [];
  const localeRu = (intl.locale || 'ru').toLowerCase().startsWith('ru');
  const [banners, setBanners] = React.useState(fallbackLinks.map((link, index) => ({
    id: index,
    title: link.title,
    url: link.url,
    body: '',
    imageUrl: '',
  })));
  const [active, setActive] = React.useState(0);

  useEffect(() => {
    const lms = config.LMS_BASE_URL;
    if (!lms) return undefined;
    let cancelled = false;
    fetch(`${lms}/urfu/api/v1/banners/`, { credentials: 'omit' })
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((data) => {
        if (cancelled) return;
        const items = Array.isArray(data) ? data : data.results;
        if (!items || !items.length) return;
        setBanners(items.map((item, index) => ({
          id: item.id || index,
          title: item.title || '',
          url: item.url || '',
          body: item.body || '',
          imageUrl: item.image_url || '',
        })));
        setActive(0);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [config.LMS_BASE_URL]);

  useEffect(() => {
    if (banners.length < 2) return undefined;
    const timer = window.setInterval(() => {
      setActive((current) => (current + 1) % banners.length);
    }, 7000);
    return () => window.clearInterval(timer);
  }, [banners]);

  if (!banners.length) {
    return null;
  }

  return (
    <div className="urfu-banner-carousel" aria-label={localeRu ? 'Информация для студентов' : 'Information for students'}>
      <style>
        {`
          .home-banner {
            overflow: visible !important;
          }
          .urfu-banner-carousel {
            width: min(1120px, calc(100% - 15rem));
            max-width: min(1120px, calc(100% - 15rem));
            margin: -8px auto 20px;
            padding: 0 4px 16px;
            position: relative;
            z-index: 2;
            pointer-events: auto;
            box-sizing: border-box;
            overflow: visible;
          }
          .urfu-banner-card {
            display: block;
            background: #fff;
            border: 1px solid rgba(21, 55, 109, 0.08);
            border-radius: 12px;
            box-shadow: 0 12px 32px rgba(11, 28, 56, 0.18), 0 2px 8px rgba(11, 28, 56, 0.06);
            padding: 16px 18px;
            min-height: 96px;
          }
          .urfu-banner-body {
            position: relative;
            overflow: visible;
          }
          .urfu-banner-slide {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            opacity: 0;
            transition: opacity 0.45s ease;
            pointer-events: none;
          }
          .urfu-banner-slide.is-active {
            position: relative;
            opacity: 1;
            pointer-events: auto;
          }
          .urfu-banner-slide-inner {
            display: flex;
            align-items: center;
            gap: 16px;
          }
          .urfu-banner-card img {
            width: 72px;
            height: 72px;
            object-fit: cover;
            border-radius: 8px;
            flex-shrink: 0;
          }
          .urfu-banner-card a,
          .urfu-banner-card strong {
            color: #15376D;
            font-weight: 700;
            text-decoration: none;
            font-size: 16px;
            display: block;
          }
          .urfu-banner-card p {
            margin: 6px 0 0;
            color: #4b5563;
            font-size: 14px;
          }
          .urfu-banner-dots {
            display: flex;
            gap: 8px;
            justify-content: center;
            margin-top: 12px;
          }
          .urfu-banner-dots button {
            width: 10px;
            height: 10px;
            padding: 0;
            border: 0;
            border-radius: 50%;
            background: #c5d4eb;
            cursor: pointer;
          }
          .urfu-banner-dots button.is-active {
            background: #15376D;
          }
          .urfu-banner-dots button:focus-visible {
            outline: 2px solid #15376D;
            outline-offset: 2px;
          }
          .urfu-banner-kicker {
            font-size: 12px;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            color: #15376D;
            margin-bottom: 6px;
          }
          html[data-paragon-theme-variant="dark"] .urfu-banner-card {
            background: #292A2C;
            border-color: #777792;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
          }
          html[data-paragon-theme-variant="dark"] .urfu-banner-kicker,
          html[data-paragon-theme-variant="dark"] .urfu-banner-card a,
          html[data-paragon-theme-variant="dark"] .urfu-banner-card strong {
            color: #AEC7F6;
          }
          html[data-paragon-theme-variant="dark"] .urfu-banner-card p {
            color: #DDDFE2;
          }
          html[data-paragon-theme-variant="dark"] .urfu-banner-dots button {
            background: #777792;
          }
          html[data-paragon-theme-variant="dark"] .urfu-banner-dots button.is-active {
            background: #AEC7F6;
          }
        `}
      </style>
      <div className="urfu-banner-card">
        <div className="urfu-banner-body">
          {banners.map((banner, index) => {
            const heading = banner.title || (localeRu ? 'Информация для студентов' : 'Information for students');
            return (
              <div
                key={banner.id || banner.url || index}
                className={`urfu-banner-slide${index === active ? ' is-active' : ''}`}
                aria-hidden={index === active ? 'false' : 'true'}
              >
                <div className="urfu-banner-slide-inner">
                  {banner.imageUrl ? <img src={banner.imageUrl} alt="" /> : null}
                  <div>
                    <div className="urfu-banner-kicker">
                      {localeRu ? 'Информация для студентов' : 'Information for students'}
                    </div>
                    {banner.url ? (
                      <a href={banner.url} target="_blank" rel="noreferrer">{heading}</a>
                    ) : (
                      <strong>{heading}</strong>
                    )}
                    {banner.body ? <p>{banner.body}</p> : null}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {banners.length > 1 ? (
        <div className="urfu-banner-dots">
          {banners.map((banner, index) => (
            <button
              key={banner.id || banner.url || index}
              type="button"
              className={index === active ? 'is-active' : ''}
              aria-label={`${index + 1}`}
              onClick={() => setActive(index)}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};


const ToggleThemeButton = ({ placement = 'desktop' }) => {
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;
  const [isDark, setIsDark] = React.useState(false);
  const themeCookieNames = ['selected-paragon-theme-variant', 'selected-theme-variant', 'theme'];
  const themeAttributeNames = ['data-paragon-theme-variant', 'data-theme-variant'];

  const readCookie = (name) => document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1];

  const getStoredTheme = () => {
    for (let i = 0; i < themeCookieNames.length; i += 1) {
      const fromCookie = readCookie(themeCookieNames[i]);
      if (fromCookie && fromCookie !== 'undefined') return fromCookie;
      const fromStore = window.localStorage.getItem(themeCookieNames[i]);
      if (fromStore && fromStore !== 'undefined') return fromStore;
    }
    return 'light';
  };

  const cookieDomain = () => {
    try {
      const lmsHost = new URL(getConfig().LMS_BASE_URL).hostname;
      const appHost = window.location.hostname;
      if (appHost === lmsHost) return lmsHost;
      if (appHost.endsWith(`.${lmsHost}`)) return `.${lmsHost}`;
      return appHost;
    } catch (e) {
      return window.location.hostname;
    }
  };

  const persistTheme = (variant) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 90);
    const domain = cookieDomain();
    themeCookieNames.forEach((name) => {
      window.localStorage.setItem(name, variant);
      document.cookie = `${name}=${variant}; domain=${domain}; path=/; expires=${expires.toUTCString()}; SameSite=Lax`;
    });
    themeAttributeNames.forEach((attr) => {
      document.documentElement.setAttribute(attr, variant);
    });
    if (document.body) {
      document.body.classList.toggle('indigo-dark-theme', variant === 'dark');
    }
  };

  useEffect(() => {
    const stored = getStoredTheme();
    setIsDark(stored === 'dark');
    persistTheme(stored);
  }, []);

  if (!isThemeToggleEnabled) {
    return null;
  }

  const toggleTheme = () => {
    const newTheme = isDark ? 'light' : 'dark';
    setIsDark(newTheme === 'dark');
    persistTheme(newTheme);
    window.setTimeout(() => {
      window.location.reload();
    }, 1);
  };

  return (
    <button
      type="button"
      className={`urfu-theme-toggle urfu-theme-toggle-${placement} ${isDark ? 'dark' : 'light'}`}
      onClick={toggleTheme}
      aria-label={isDark ? 'Светлая тема' : 'Тёмная тема'}
      title={isDark ? 'Светлая тема' : 'Тёмная тема'}
    >
      <style>
        {`
          button.urfu-theme-toggle {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            margin-inline: 8px 12px;
            padding: 0;
            border: 1px solid rgba(21, 55, 109, 0.18);
            border-radius: 8px;
            background: #fff;
            color: #15376D;
            cursor: pointer;
            line-height: 0;
          }
          button.urfu-theme-toggle svg {
            width: 18px;
            height: 18px;
          }
          button.urfu-theme-toggle:focus-visible {
            outline: 2px solid #15376D;
            outline-offset: 2px;
          }
          [data-paragon-theme-variant="dark"] button.urfu-theme-toggle {
            background: #112F6B !important;
            border-color: rgba(174, 199, 246, 0.35) !important;
            color: #AEC7F6 !important;
          }
          header.site-header-mobile .menu button.urfu-theme-toggle {
            width: 36px !important;
            height: 36px !important;
            padding: 0 !important;
            border: 1px solid rgba(21, 55, 109, 0.18) !important;
            background: #fff !important;
          }
          html[data-paragon-theme-variant="dark"] header.site-header-mobile .menu button.urfu-theme-toggle,
          html[data-paragon-theme-variant="dark"] button.urfu-theme-toggle-mobile {
            background: #112F6B !important;
            border-color: rgba(174, 199, 246, 0.35) !important;
            color: #AEC7F6 !important;
          }
          @media (min-width: 992px) {
            button.urfu-theme-toggle-mobile {
              display: none !important;
            }
          }
          @media (max-width: 991.98px) {
            button.urfu-theme-toggle-desktop {
              display: none !important;
            }
          }
        `}
      </style>
      {isDark ? (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="5" />
          <line x1="12" y1="1" x2="12" y2="3" />
          <line x1="12" y1="21" x2="12" y2="23" />
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
          <line x1="1" y1="12" x2="3" y2="12" />
          <line x1="21" y1="12" x2="23" y2="12" />
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      )}
    </button>
  );
};


const URFU_LOGO_COLOR = 'https://openedu.urfu.ru/files/courses_catalog/UrFULogo1.svg';

const urfuLogoUrl = () => {
  const config = getConfig();
  const isDark = typeof document !== 'undefined'
    && document.documentElement.getAttribute('data-paragon-theme-variant') === 'dark';
  if (isDark && config.LMS_BASE_URL) {
    return `${config.LMS_BASE_URL}/theming/asset/images/logo-urfu-white.svg`;
  }
  return config.LOGO_URL || URFU_LOGO_COLOR;
};

const ThemedLogo = () => {
  const config = getConfig();
  // Learning MFE at /learning is empty without a course. Logo goes to LMS home.
  const href = config.LMS_BASE_URL || '/';

  return (
    <a className="urfu-themed-logo" href={href} aria-label="УрФУ.Онлайн">
      <style>
        {`
          a.urfu-themed-logo {
            display: inline-flex;
            align-items: center;
            max-height: 40px;
            margin-right: 1.5rem;
          }
          a.urfu-themed-logo img {
            height: 36px;
            width: auto;
            max-width: 180px;
            object-fit: contain;
          }
          a.urfu-themed-logo img:not([src*="white"]) {
            filter: brightness(0) saturate(100%) invert(16%) sepia(48%) saturate(1650%) hue-rotate(196deg) brightness(92%) contrast(95%);
          }
        `}
      </style>
      <img src={urfuLogoUrl()} alt="УрФУ.Онлайн" className="logo-image" />
    </a>
  );
};


const MobileViewHeader = () => (
  <ToggleThemeButton placement="mobile" />
);


const urfuCatalogSearchBus = {
  listeners: new Set(),
  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  },
  publish(query) {
    this.listeners.forEach((listener) => listener(query));
  },
};

const UrfuCatalogSearchBridge = ({ setSearchInput, handleSearch }) => {
  useEffect(() => {
    return urfuCatalogSearchBus.subscribe((query) => {
      if (typeof setSearchInput === 'function') {
        setSearchInput(query);
      }
      if (typeof handleSearch === 'function') {
        handleSearch(query);
      }
    });
  }, [setSearchInput, handleSearch]);
  return null;
};

const URFU_CATALOG_PAGE_SIZE = 20;

function expandFilterToken(value) {
  const year = new Date().getFullYear();
  return String(value == null ? '' : value)
    .replace(/\{year-1\}/g, String(year - 1))
    .replace(/\{year\+1\}/g, String(year + 1))
    .replace(/\{year\}/g, String(year));
}

function defaultCatalogFilters() {
  return [
    { id: 'all', label: 'Все курсы', query: '' },
    { id: 'now', label: 'Идут сейчас', query: 'now' },
    { id: 'prev_fall', label: 'Осень {year-1}', query: '{year-1}_fall' },
    { id: 'spring', label: 'Весна {year}', query: '{year}_spring' },
    { id: 'fall', label: 'Осень {year}', query: '{year}_fall' },
    { id: 'next_spring', label: 'Весна {year+1}', query: '{year+1}_spring' },
  ];
}

function resolveCatalogFilters(raw) {
  const source = Array.isArray(raw) && raw.length ? raw : defaultCatalogFilters();
  return source.map((chip, index) => {
    const queryRaw = chip.query == null ? '' : String(chip.query);
    const query = queryRaw === '{now}' ? 'now' : expandFilterToken(queryRaw);
    return {
      id: expandFilterToken(chip.id || `filter-${index}`),
      label: expandFilterToken(chip.label || query || 'Фильтр'),
      query,
    };
  });
}

function catalogSearchQuery() {
  if (typeof window === 'undefined') {
    return '';
  }
  return new URLSearchParams(window.location.search).get('search_query') || '';
}

function formatUrfuDate(value, prefix) {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const locale = (typeof navigator !== 'undefined' && navigator.language) || 'ru-RU';
  return `${prefix} ${date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })}`;
}

function absoluteMediaUrl(path) {
  if (!path) {
    return '';
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const lms = (getConfig().LMS_BASE_URL || '').replace(/\/$/, '');
  return `${lms}${path.startsWith('/') ? path : `/${path}`}`;
}

function mapApiCourse(row) {
  return {
    id: row.id || '',
    title: row.title || 'Курс',
    org: row.org || '',
    number: row.number || '',
    start: row.start || '',
    end: row.end || '',
    imageUrl: absoluteMediaUrl(row.imageUrl || row.image_url || ''),
  };
}

function courseAboutUrl(courseId) {
  return `/catalog/courses/${courseId}/about`;
}

function courseLearningUrl(courseId) {
  const learning = String(getConfig().LEARNING_BASE_URL || '').replace(/\/$/, '');
  if (/^https?:\/\//i.test(learning)) {
    return `${learning}/course/${courseId}/home`;
  }
  const appsOrigin = window.location.origin.replace(/:\d+$/, ':2000');
  return `${appsOrigin}/learning/course/${courseId}/home`;
}

function courseImageUrl(path) {
  const lms = (getConfig().LMS_BASE_URL || '').replace(/\/$/, '');
  const fallback = `${lms}/theming/asset/images/no_course_image.png`;
  if (!path) {
    return fallback;
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  return `${lms}${path.startsWith('/') ? path : `/${path}`}`;
}

const UrfuCatalogResultCard = ({ course }) => {
  if (!course || !course.id) {
    return null;
  }
  const aboutUrl = courseAboutUrl(course.id);
  const learnUrl = courseLearningUrl(course.id);
  const fallbackImage = courseImageUrl('');
  const imageSrc = courseImageUrl(course.imageUrl);
  const startLabel = formatUrfuDate(course.start, 'Начало:');
  const endLabel = formatUrfuDate(course.end, 'Окончание:');
  return (
    <div className="urfu-catalog-course-card">
      <article className="pgn__card course-card">
        <div className="pgn__card-image-cap">
          <img
            src={imageSrc}
            alt=""
            onError={(event) => {
              if (event.currentTarget.src !== fallbackImage) {
                event.currentTarget.src = fallbackImage;
              }
            }}
          />
        </div>
        <div className="pgn__card-header">
          <div className="pgn__card-header-title pgn__card-header-title-md">{course.title}</div>
          <div className="pgn__card-header-subtitle">
            {course.number ? <span>{course.number}</span> : null}
            {course.org ? <span> {course.org}</span> : null}
          </div>
        </div>
        <div className="pgn__card-footer urfu-catalog-course-card__meta">
          {startLabel ? <div className="pgn__card-footer-text">{startLabel}</div> : null}
          {endLabel ? <div className="pgn__card-footer-text">{endLabel}</div> : null}
        </div>
      </article>
      <div className="urfu-catalog-result-card__actions">
        <a className="urfu-catalog-result-card__about" href={aboutUrl}>Подробнее</a>
        <a
          className="urfu-catalog-result-card__learn"
          href={learnUrl}
          aria-label="Перейти к курсу"
          title="Перейти к курсу"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M14 5h5v5" />
            <path d="M10 14 19 5" />
            <path d="M19 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h7" />
          </svg>
        </a>
      </div>
    </div>
  );
};

const UrfuCatalogFilters = ({ chips, active, onSelect }) => (
  <aside className="urfu-catalog-sidebar" aria-label="Фильтры">
    <h2 className="urfu-catalog-sidebar__title">Фильтры</h2>
    <p className="urfu-catalog-sidebar__hint">По семестру запуска</p>
    <div className="urfu-catalog-filters" role="list">
      {chips.map((chip) => (
        <button
          key={chip.id}
          type="button"
          role="listitem"
          className={active === chip.id ? 'is-active' : ''}
          aria-pressed={active === chip.id}
          onClick={() => onSelect(chip)}
        >
          {chip.label}
        </button>
      ))}
    </div>
  </aside>
);

const UrfuCatalogDataTable = () => {
  const config = getConfig();
  const chips = resolveCatalogFilters(config.URFU_CATALOG_FILTERS);
  const [active, setActive] = React.useState(chips[0] ? chips[0].id : 'all');
  const [page, setPage] = React.useState(0);
  const [apiState, setApiState] = React.useState({
    status: 'idle',
    results: [],
    total: 0,
    pageCount: 1,
  });

  const activeChip = chips.find((chip) => chip.id === active) || chips[0] || { id: 'all', query: '' };
  const searchQuery = catalogSearchQuery();

  useEffect(() => {
    const lms = (getConfig().LMS_BASE_URL || '').replace(/\/$/, '');
    if (!lms) {
      setApiState({ status: 'error', results: [], total: 0, pageCount: 1 });
      return undefined;
    }
    let cancelled = false;
    setApiState((prev) => ({ ...prev, status: 'loading' }));
    const params = new URLSearchParams({
      run: activeChip.query || '',
      search: searchQuery,
      page_index: String(page),
      page_size: String(URFU_CATALOG_PAGE_SIZE),
    });
    fetch(`${lms}/urfu/api/v1/catalog/courses/?${params.toString()}`, { credentials: 'omit' })
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((payload) => {
        if (cancelled) {
          return;
        }
        const results = (payload.results || []).map(mapApiCourse);
        const total = Number(payload.total || results.length);
        const count = Math.max(1, Math.ceil(total / URFU_CATALOG_PAGE_SIZE) || 1);
        setApiState({
          status: 'ready',
          results,
          total,
          pageCount: total ? count : 1,
        });
      })
      .catch(() => {
        if (!cancelled) {
          setApiState({ status: 'error', results: [], total: 0, pageCount: 1 });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [activeChip.query, searchQuery, page]);

  const applyChip = (chip) => {
    setActive(chip.id);
    setPage(0);
  };

  const courses = apiState.results;
  const total = apiState.total;
  const currentPage = page;
  const pages = Math.max(1, apiState.pageCount || 1);
  const from = total ? currentPage * URFU_CATALOG_PAGE_SIZE + 1 : 0;
  const to = Math.min(total, (currentPage + 1) * URFU_CATALOG_PAGE_SIZE);
  const loading = apiState.status === 'loading' || apiState.status === 'idle';

  return (
    <div className="urfu-catalog-layout">
      <style>
        {`
          .urfu-catalog-layout { display: flex; flex-direction: column; gap: 1.25rem; width: 100%; }
          .urfu-catalog-sidebar { width: 100%; background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 1rem; box-shadow: 0 1px 3px rgba(21,55,109,0.08), 0 1px 2px rgba(0,0,0,0.04); }
          .urfu-catalog-sidebar__title { margin: 0; font-size: 1.05rem; font-weight: 700; color: #15376D; }
          .urfu-catalog-sidebar__hint { margin: 0.25rem 0 0.85rem; font-size: 13px; color: #6b7280; }
          .urfu-catalog-filters { display: flex; flex-wrap: wrap; gap: 8px; }
          .urfu-catalog-filters button { border: 1px solid #e5e7eb; background: #f4f7fb; color: #15376D; border-radius: 10px; padding: 10px 12px; font-size: 14px; font-weight: 600; cursor: pointer; }
          .urfu-catalog-filters button.is-active { background: #15376D; border-color: #15376D; color: #fff; }
          .urfu-catalog-filters button:focus-visible { outline: 2px solid #15376D; outline-offset: 2px; }
          .urfu-catalog-results { min-width: 0; flex: 1 1 auto; }
          .urfu-catalog-results__status { font-size: 13px; color: #6b7280; margin-bottom: 0.85rem; }
          .urfu-catalog-results__empty { margin: 0; padding: 1.25rem 1rem; background: #f4f7fb; border-radius: 12px; color: #374151; font-size: 14px; }
          .urfu-catalog-grid { display: grid; grid-template-columns: 1fr; justify-content: start; gap: 1.25rem; }
          .urfu-catalog-course-card { display: flex; flex-direction: column; width: 100%; max-width: 100%; background: #fff; border-radius: 12px; overflow: hidden; box-shadow: 0 1px 3px rgba(21,55,109,0.08), 0 1px 2px rgba(0,0,0,0.04); }
          .urfu-catalog-course-card .pgn__card.course-card { box-shadow: none !important; border: none !important; margin-bottom: 0 !important; height: auto; }
          .urfu-catalog-course-card .pgn__card-image-cap,
          .urfu-catalog-course-card .pgn__card-image-cap img { width: 100%; height: 140px; min-height: 140px; max-height: 140px; object-fit: cover; background: #eef3fa; display: block; }
          .urfu-catalog-course-card .pgn__card-header { display: flex; flex-direction: column; align-items: stretch; gap: 0.35rem; padding: 1rem 1rem 0.25rem; }
          .urfu-catalog-course-card .pgn__card-header-subtitle { margin-left: 0 !important; width: 100%; }
          .urfu-catalog-course-card__meta { display: flex; flex-direction: column; align-items: flex-start; gap: 0.15rem; padding: 0 1rem 0.5rem; }
          .urfu-catalog-course-card .pgn__card-footer-text { white-space: normal; }
          .urfu-catalog-result-card__actions { display: flex; align-items: center; gap: 8px; padding: 0 1rem 1rem; }
          .urfu-catalog-result-card__about { flex: 1 1 auto; display: inline-flex; align-items: center; justify-content: center; min-height: 42px; border-radius: 10px; background: #15376D; color: #fff !important; font-size: 14px; font-weight: 600; text-decoration: none !important; }
          .urfu-catalog-result-card__learn { flex: 0 0 42px; width: 42px; height: 42px; display: inline-flex; align-items: center; justify-content: center; border: 1px solid #e5e7eb; border-radius: 10px; background: #fff; color: #15376D; text-decoration: none; }
          .urfu-catalog-result-card__about:focus-visible, .urfu-catalog-result-card__learn:focus-visible { outline: 2px solid #15376D; outline-offset: 2px; }
          .urfu-catalog-pager { display: flex; align-items: center; justify-content: flex-end; gap: 10px; margin-top: 1.25rem; }
          .urfu-catalog-pager button { width: 36px; height: 36px; border: 1px solid #e5e7eb; background: #fff; color: #15376D; border-radius: 8px; font-size: 20px; line-height: 1; cursor: pointer; }
          .urfu-catalog-pager button:disabled { opacity: 0.45; cursor: default; }
          .urfu-catalog-pager button:focus-visible { outline: 2px solid #15376D; outline-offset: 2px; }
          @media (min-width: 768px) {
            .urfu-catalog-layout { flex-direction: row; align-items: flex-start; gap: 2rem; }
            .urfu-catalog-sidebar { flex: 0 0 240px; }
            .urfu-catalog-filters { flex-direction: column; }
            .urfu-catalog-filters button { width: 100%; }
            .urfu-catalog-grid { grid-template-columns: repeat(auto-fill, 260px); }
            .urfu-catalog-course-card { width: 260px; max-width: 260px; }
          }
          html[data-paragon-theme-variant="dark"] .urfu-catalog-sidebar,
          html[data-paragon-theme-variant="dark"] .urfu-catalog-course-card { background: #292A2C; border: 1px solid #777792; box-shadow: none; }
          html[data-paragon-theme-variant="dark"] .urfu-catalog-result-card__learn { background: #1f2023; border-color: #777792; color: #C5D4EB; }
          html[data-paragon-theme-variant="dark"] .urfu-catalog-filters button { background: #1f2023; border-color: #777792; color: #F9FAFB; }
          html[data-paragon-theme-variant="dark"] .urfu-catalog-filters button.is-active { background: #15376D; border-color: #15376D; color: #fff; }
        `}
      </style>
      <UrfuCatalogFilters chips={chips} active={active} onSelect={applyChip} />
      <div className="urfu-catalog-results">
        <div className="urfu-catalog-results__status">
          {loading ? 'Загрузка курсов…' : `Показано ${from} – ${to} из ${total}.`}
        </div>
        {apiState.status === 'error' ? (
          <p className="urfu-catalog-results__empty">Не удалось загрузить курсы выбранного семестра.</p>
        ) : null}
        {!loading && !courses.length ? (
          <p className="urfu-catalog-results__empty">Курсы не найдены. Измените фильтр или поисковый запрос.</p>
        ) : (
          <div className="urfu-catalog-grid">
            {courses.map((course) => (
              <UrfuCatalogResultCard key={course.id} course={course} />
            ))}
          </div>
        )}
        <div className="urfu-catalog-pager">
          <button
            type="button"
            disabled={currentPage <= 0}
            onClick={() => setPage(currentPage - 1)}
            aria-label="Назад"
          >
            ‹
          </button>
          <span>{currentPage + 1} / {pages}</span>
          <button
            type="button"
            disabled={currentPage + 1 >= pages}
            onClick={() => setPage(currentPage + 1)}
            aria-label="Вперёд"
          >
            ›
          </button>
        </div>
      </div>
    </div>
  );
};


/* Shared public deadlines for catalog course-about (sidebar summary + overview schedule). */

const urfuDeadlinesCache = new Map();

const resolveCourseId = (explicit) => {
  if (explicit) return explicit;
  if (typeof window === 'undefined') return '';
  return (window.location.pathname.match(/course-v1:[^/]+/) || [])[0] || '';
};

const formatExamDate = (value, locale) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

const monthKey = (value, locale) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'other';
  return `${date.getFullYear()}-${String(date.getMonth()).padStart(2, '0')}`;
};

const formatMonthHeading = (value, locale) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const label = date.toLocaleDateString(locale, { month: 'long', year: 'numeric' });
  return label.charAt(0).toUpperCase() + label.slice(1);
};

const fetchCourseDeadlines = (courseId) => {
  if (!courseId) {
    return Promise.resolve([]);
  }
  if (urfuDeadlinesCache.has(courseId)) {
    return urfuDeadlinesCache.get(courseId);
  }
  const lms = getConfig().LMS_BASE_URL;
  if (!lms) {
    const empty = Promise.resolve([]);
    urfuDeadlinesCache.set(courseId, empty);
    return empty;
  }
  const url = `${lms}/urfu/api/v1/deadlines/?course=${encodeURIComponent(courseId)}`;
  const pending = fetch(url, { credentials: 'omit' })
    .then((res) => (res.ok ? res.json() : Promise.reject(res)))
    .then((data) => {
      const publicRows = data.deadlines || data.results || [];
      return (Array.isArray(publicRows) ? publicRows : [])
        .map((block) => ({
          title: block.title || block.display_name || 'Подраздел',
          date: block.date || block.due,
        }))
        .filter((row) => row.date)
        .sort((a, b) => new Date(a.date) - new Date(b.date));
    })
    .catch(() => []);
  urfuDeadlinesCache.set(courseId, pending);
  return pending;
};

const pickNearestDeadline = (rows) => {
  if (!rows.length) return null;
  const now = Date.now();
  const upcoming = rows.find((row) => new Date(row.date).getTime() >= now);
  return upcoming || rows[rows.length - 1];
};

const groupRowsByMonth = (rows, locale) => {
  const groups = [];
  const indexByKey = new Map();
  rows.forEach((row) => {
    const key = monthKey(row.date, locale);
    if (!indexByKey.has(key)) {
      indexByKey.set(key, groups.length);
      groups.push({
        key,
        label: formatMonthHeading(row.date, locale),
        rows: [],
      });
    }
    groups[indexByKey.get(key)].rows.push(row);
  });
  return groups;
};

const useCourseDeadlines = (courseId) => {
  const [rows, setRows] = React.useState([]);
  const [status, setStatus] = React.useState(courseId ? 'loading' : 'empty');

  React.useEffect(() => {
    if (!courseId) {
      setRows([]);
      setStatus('empty');
      return undefined;
    }
    let cancelled = false;
    setStatus('loading');
    fetchCourseDeadlines(courseId).then((mapped) => {
      if (cancelled) return;
      if (mapped.length) {
        setRows(mapped);
        setStatus('ready');
      } else {
        setRows([]);
        setStatus('empty');
      }
    });
    return () => { cancelled = true; };
  }, [courseId]);

  return { rows, status };
};

const PREVIEW_LIMIT = 5;

/** Compact summary for the right sidebar — no long list. */
const UrfuExamDates = (props) => {
  const courseAboutData = props.courseAboutData || {};
  const locale = (typeof navigator !== 'undefined' && navigator.language) || 'ru-RU';
  const courseId = resolveCourseId(
    courseAboutData.id || courseAboutData.courseId || '',
  );
  const { rows, status } = useCourseDeadlines(courseId);
  const endDate = courseAboutData.end || courseAboutData.endDate || courseAboutData.pacingEnd;
  const nearest = status === 'ready' ? pickNearestDeadline(rows) : null;

  return (
    <div className="urfu-exam-dates urfu-exam-dates-summary p-3">
      <style>
        {`
          .urfu-exam-dates-summary h3 {
            font-size: 0.85rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            color: #15376D;
            margin: 0 0 0.65rem;
          }
          .urfu-exam-dates-summary .muted { color: #6b7280; font-size: 0.85rem; margin: 0; }
          .urfu-exam-dates-summary__meta {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 0.5rem;
            margin: 0 0 0.5rem;
          }
          .urfu-exam-dates-summary__count {
            display: inline-flex;
            align-items: center;
            min-height: 1.5rem;
            padding: 0 0.55rem;
            border-radius: 999px;
            background: rgba(21, 55, 109, 0.08);
            color: #15376D;
            font-size: 0.8rem;
            font-weight: 650;
          }
          .urfu-exam-dates-summary__nearest {
            margin: 0 0 0.75rem;
            font-size: 0.9rem;
            line-height: 1.4;
            color: #111827;
          }
          .urfu-exam-dates-summary__nearest strong { font-weight: 650; }
          .urfu-exam-dates-summary__link {
            display: inline-flex;
            align-items: center;
            font-size: 0.875rem;
            font-weight: 600;
            color: #15376D !important;
            text-decoration: underline;
            text-underline-offset: 2px;
          }
          .urfu-exam-dates-summary__link:focus-visible {
            outline: 2px solid #15376D;
            outline-offset: 2px;
            border-radius: 4px;
          }
        `}
      </style>
      <h3>Контрольные испытания</h3>
      {status === 'loading' && <p className="muted">Загрузка дат…</p>}
      {status === 'ready' && (
        <>
          <div className="urfu-exam-dates-summary__meta">
            <span className="urfu-exam-dates-summary__count">
              {rows.length}
              {' '}
              {rows.length === 1 ? 'срок' : (rows.length >= 2 && rows.length <= 4 ? 'срока' : 'сроков')}
            </span>
          </div>
          {nearest ? (
            <p className="urfu-exam-dates-summary__nearest">
              Ближайший:
              {' '}
              <strong>
                до
                {' '}
                {formatExamDate(nearest.date, locale)}
              </strong>
            </p>
          ) : null}
          <a className="urfu-exam-dates-summary__link" href="#urfu-exam-schedule">
            Смотреть расписание
          </a>
        </>
      )}
      {status === 'empty' && (
        <p className="muted">
          {endDate
            ? `Отдельные сроки испытаний не опубликованы. Курс завершается ${formatExamDate(endDate, locale)}.`
            : 'Сроки закрытия контрольных испытаний появятся, когда расписание будет опубликовано в курсе.'}
        </p>
      )}
    </div>
  );
};

/** Full schedule in main column (overview slot) — grouped by month, progressive disclosure. */
const UrfuExamScheduleSection = (props) => {
  const locale = (typeof navigator !== 'undefined' && navigator.language) || 'ru-RU';
  const courseId = resolveCourseId(props.courseId || '');
  const { rows, status } = useCourseDeadlines(courseId);
  const [expanded, setExpanded] = React.useState(false);

  if (status !== 'ready' || !rows.length) {
    return null;
  }

  const visibleRows = expanded ? rows : rows.slice(0, PREVIEW_LIMIT);
  const groups = groupRowsByMonth(visibleRows, locale);
  const hiddenCount = rows.length - PREVIEW_LIMIT;
  const showToggle = rows.length > PREVIEW_LIMIT;

  return (
    <section id="urfu-exam-schedule" className="urfu-exam-schedule" aria-labelledby="urfu-exam-schedule-title">
      <style>
        {`
          .urfu-exam-schedule {
            width: 100%;
            box-sizing: border-box;
            margin: 0 0 1.5rem;
            background: #fff;
            border: 1px solid rgba(21, 55, 109, 0.08);
            border-radius: 12px;
            box-shadow: 0 1px 3px rgba(21, 55, 109, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
            padding: 1rem 1.1rem 1.1rem;
          }
          .urfu-exam-schedule__header {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 0.65rem;
            margin: 0 0 0.85rem;
          }
          .urfu-exam-schedule__header h2 {
            margin: 0;
            font-size: 1.15rem;
            font-weight: 700;
            color: #15376D;
            line-height: 1.3;
          }
          .urfu-exam-schedule__badge {
            display: inline-flex;
            align-items: center;
            min-height: 1.5rem;
            padding: 0 0.55rem;
            border-radius: 999px;
            background: rgba(21, 55, 109, 0.08);
            color: #15376D;
            font-size: 0.8rem;
            font-weight: 650;
          }
          .urfu-exam-schedule__body {
            max-height: none;
          }
          .urfu-exam-schedule__body.is-expanded {
            max-height: 28rem;
            overflow-y: auto;
            padding-right: 0.25rem;
          }
          .urfu-exam-schedule__month {
            margin: 0 0 0.85rem;
          }
          .urfu-exam-schedule__month:last-child { margin-bottom: 0; }
          .urfu-exam-schedule__month-title {
            position: sticky;
            top: 0;
            z-index: 1;
            margin: 0 0 0.35rem;
            padding: 0.35rem 0;
            font-size: 0.8rem;
            font-weight: 700;
            letter-spacing: 0.03em;
            text-transform: uppercase;
            color: #6b7280;
            background: #fff;
          }
          .urfu-exam-schedule__list {
            list-style: none;
            margin: 0;
            padding: 0;
          }
          .urfu-exam-schedule__list li {
            display: grid;
            grid-template-columns: 1fr auto;
            gap: 0.75rem 1rem;
            align-items: baseline;
            padding: 0.55rem 0;
            border-bottom: 1px solid #f3f4f6;
            font-size: 0.95rem;
            line-height: 1.35;
          }
          .urfu-exam-schedule__list li:last-child { border-bottom: none; }
          .urfu-exam-schedule__title { color: #111827; }
          .urfu-exam-schedule__date {
            color: #15376D;
            font-weight: 650;
            white-space: nowrap;
            text-align: right;
          }
          .urfu-exam-schedule__toggle {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-top: 0.85rem;
            min-height: 2.25rem;
            padding: 0 0.9rem;
            border: 1px solid rgba(21, 55, 109, 0.22);
            border-radius: 8px;
            background: #fff;
            color: #15376D;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
          }
          .urfu-exam-schedule__toggle:focus-visible {
            outline: 2px solid #15376D;
            outline-offset: 2px;
          }
          @media (max-width: 575.98px) {
            .urfu-exam-schedule__list li {
              grid-template-columns: 1fr;
              gap: 0.2rem;
            }
            .urfu-exam-schedule__date { text-align: left; white-space: normal; }
          }
        `}
      </style>
      <div className="urfu-exam-schedule__header">
        <h2 id="urfu-exam-schedule-title">Контрольные испытания</h2>
        <span className="urfu-exam-schedule__badge">{rows.length}</span>
      </div>
      <div className={`urfu-exam-schedule__body${expanded ? ' is-expanded' : ''}`}>
        {groups.map((group) => (
          <div className="urfu-exam-schedule__month" key={group.key}>
            <div className="urfu-exam-schedule__month-title">{group.label}</div>
            <ul className="urfu-exam-schedule__list">
              {group.rows.map((row) => (
                <li key={`${row.title}-${row.date}`}>
                  <span className="urfu-exam-schedule__title">{row.title}</span>
                  <span className="urfu-exam-schedule__date">
                    до
                    {' '}
                    {formatExamDate(row.date, locale)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {showToggle ? (
        <button
          type="button"
          className="urfu-exam-schedule__toggle"
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? 'Свернуть' : `Показать все (${rows.length})`}
        </button>
      ) : null}
      {showToggle && !expanded && hiddenCount > 0 ? (
        <span className="sr-only">
          Скрыто ещё
          {' '}
          {hiddenCount}
          {' '}
          сроков
        </span>
      ) : null}
    </section>
  );
};

const UrfuCourseAboutSidebar = ({ courseAboutData }) => {
  const data = courseAboutData || {};
  const locale = (typeof navigator !== 'undefined' && navigator.language) || 'ru-RU';
  const details = [
    {
      label: 'Номер курса',
      value: data.displayNumberWithDefault,
    },
    {
      label: 'Начало',
      value: data.startDateIsStillDefault ? '' : formatExamDate(data.advertisedStart || data.start, locale),
    },
    {
      label: 'Окончание',
      value: formatExamDate(data.end, locale),
    },
    {
      label: 'Нагрузка',
      value: data.effort,
    },
  ].filter((row) => row.value);

  return (
    <aside className="urfu-course-about-sidebar">
      <style>
        {`
          .urfu-course-about-sidebar {
            background: #fff;
            border: 1px solid rgba(21, 55, 109, 0.08);
            border-radius: 12px;
            box-shadow: 0 1px 3px rgba(21, 55, 109, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
            overflow: hidden;
          }
          .urfu-course-about-details {
            list-style: none;
            margin: 0;
            padding: 0 1rem 1rem;
            border-top: 1px solid #f3f4f6;
          }
          .urfu-course-about-details li {
            display: flex;
            justify-content: space-between;
            gap: 12px;
            font-size: 0.9rem;
            line-height: 1.35;
            padding: 0.55rem 0;
            border-bottom: 1px solid #f3f4f6;
          }
          .urfu-course-about-details li:last-child { border-bottom: none; }
          .urfu-course-about-details span { color: #6b7280; }
          .urfu-course-about-details strong { color: #111827; font-weight: 600; text-align: right; }
        `}
      </style>
      {details.length ? (
        <ul className="urfu-course-about-details" style={{ borderTop: 'none', paddingTop: '1rem' }}>
          {details.map((row) => (
            <li key={row.label}>
              <span>{row.label}</span>
              <strong>{row.value}</strong>
            </li>
          ))}
        </ul>
      ) : null}
      <UrfuExamDates courseAboutData={data} />
    </aside>
  );
};

const dayKey = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'invalid';
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

const formatDatesTabDay = (value, locale) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(locale, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

const formatDatesTabTime = (value, locale) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });
};

const groupExamRowsByDay = (rows) => {
  const groups = [];
  const indexByKey = new Map();
  rows.forEach((row) => {
    const key = dayKey(row.date);
    if (!indexByKey.has(key)) {
      indexByKey.set(key, groups.length);
      groups.push({ key, date: row.date, rows: [] });
    }
    groups[indexByKey.get(key)].rows.push(row);
  });
  return groups;
};

/** Learning MFE dates tab — same public deadlines, timeline UX (not catalog cards). */
const UrfuLearningDatesExams = () => {
  const locale = (typeof navigator !== 'undefined' && navigator.language) || 'ru-RU';
  const courseId = resolveCourseId('');
  const { rows, status } = useCourseDeadlines(courseId);
  const now = Date.now();

  if (status === 'loading' || status === 'empty' || !rows.length) {
    return null;
  }

  const groups = groupExamRowsByDay(rows);

  return (
    <section className="urfu-learning-dates-exams mt-3 mb-2" aria-labelledby="urfu-learning-dates-exams-title">
      <style>
        {`
          .urfu-learning-dates-exams { width: 100%; }
          .urfu-learning-dates-exams__title {
            font-size: 1rem;
            font-weight: 700;
            color: #15376D;
            margin: 0 0 0.25rem;
          }
          .urfu-learning-dates-exams__list {
            list-style: none;
            margin: 0;
            padding: 0.5rem 0 0;
          }
          .urfu-learning-dates-exams__day {
            position: relative;
            padding-bottom: 1.25rem;
          }
          .urfu-learning-dates-exams__line {
            position: absolute;
            left: 0.45rem;
            top: 0;
            bottom: 0;
            width: 1px;
            background: #111827;
          }
          .urfu-learning-dates-exams__dot {
            position: absolute;
            left: 0.22rem;
            top: 0.45rem;
            width: 0.6rem;
            height: 0.6rem;
            border-radius: 50%;
            border: 1px solid #111827;
            background: #15376D;
            z-index: 1;
          }
          .urfu-learning-dates-exams__body {
            display: inline-block;
            margin-left: 1.35rem;
            padding-left: 0.5rem;
            max-width: calc(100% - 1.5rem);
          }
          .urfu-learning-dates-exams__header {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 0.35rem 0.5rem;
            color: #15376D;
            font-size: 0.95rem;
            margin-bottom: 0.25rem;
          }
          .urfu-learning-dates-exams__badge {
            display: inline-flex;
            align-items: center;
            min-height: 1.35rem;
            padding: 0 0.45rem;
            border-radius: 0.25rem;
            background: #e5e7eb;
            color: #111827;
            font-size: 0.75rem;
            font-weight: 600;
          }
          .urfu-learning-dates-exams__badge.is-past {
            background: #4b5563;
            color: #fff;
          }
          .urfu-learning-dates-exams__item {
            font-size: 0.875rem;
            color: #15376D;
            padding-bottom: 0.25rem;
          }
          .urfu-learning-dates-exams__item-title { font-weight: 700; }
          .urfu-learning-dates-exams__item-due { margin-left: 0.35rem; }
        `}
      </style>
      <h2 id="urfu-learning-dates-exams-title" className="urfu-learning-dates-exams__title">
        Контрольные испытания
      </h2>
      <ul className="urfu-learning-dates-exams__list">
        {groups.map((group) => (
          <li className="urfu-learning-dates-exams__day" key={group.key}>
            <div className="urfu-learning-dates-exams__line" aria-hidden="true" />
            <div className="urfu-learning-dates-exams__dot" aria-hidden="true" />
            <div className="urfu-learning-dates-exams__body">
              <div className="urfu-learning-dates-exams__header">
                <span>{formatDatesTabDay(group.date, locale)}</span>
              </div>
              {group.rows.map((row) => {
                const past = new Date(row.date).getTime() < now;
                return (
                  <div className="urfu-learning-dates-exams__item" key={`${row.title}-${row.date}`}>
                    <span className="urfu-learning-dates-exams__item-title">{row.title}</span>
                    <span className="urfu-learning-dates-exams__item-due">
                      до
                      {' '}
                      {formatDatesTabTime(row.date, locale)}
                    </span>
                    {' '}
                    <span className={`urfu-learning-dates-exams__badge${past ? ' is-past' : ''}`}>
                      {past ? 'Просрочено' : 'Контроль'}
                    </span>
                  </div>
                );
              })}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};


/**
 * Header account-menu toggles: full name, then email, then username.
 * Slot mergeProps: desktop/mobile { avatar, label }, learning { label, icon }.
 * Core header `label` is username. Account "Полное имя" is user.name / accounts API.
 */
let urfuPreferredLabelCache = null;

const urfuTrim = (value) => (typeof value === 'string' ? value.trim() : '');

const urfuReadUser = () => (
  typeof getUrfuAuthenticatedUser === 'function' ? getUrfuAuthenticatedUser() : null
);

const urfuDistinctName = (name, username) => {
  const trimmed = urfuTrim(name);
  if (!trimmed || trimmed === urfuTrim(username)) {
    return '';
  }
  return trimmed;
};

const urfuResolveAccountLabel = (fallbackLabel) => {
  if (urfuPreferredLabelCache) {
    return urfuPreferredLabelCache;
  }
  const user = urfuReadUser();
  const name = urfuDistinctName(user && user.name, user && user.username);
  if (name) {
    return name;
  }
  const email = urfuTrim(user && user.email);
  if (email) {
    return email;
  }
  if (fallbackLabel) {
    return fallbackLabel;
  }
  return urfuTrim(user && user.username);
};

const urfuLoadPreferredAccountLabel = (fallbackLabel) => {
  const syncLabel = urfuResolveAccountLabel(fallbackLabel);
  if (urfuPreferredLabelCache) {
    return Promise.resolve(urfuPreferredLabelCache);
  }
  const user = urfuReadUser();
  const username = urfuTrim(user && user.username);
  const lmsBase = typeof getConfig === 'function' ? getConfig().LMS_BASE_URL : '';
  if (!username || !lmsBase || typeof getUrfuHttpClient !== 'function') {
    return Promise.resolve(syncLabel);
  }
  return getUrfuHttpClient()
    .get(`${lmsBase}/api/user/v1/accounts/${encodeURIComponent(username)}`)
    .then((response) => {
      const account = response && response.data;
      const name = urfuDistinctName(account && account.name, username);
      if (!name) {
        return syncLabel;
      }
      urfuPreferredLabelCache = name;
      return name;
    })
    .catch(() => syncLabel);
};

const urfuModifyUserMenuToggleLabel = (widget) => {
  const content = widget.content ? { ...widget.content } : {};
  content.label = urfuResolveAccountLabel(content.label);
  return { ...widget, content };
};

const urfuUseAccountMenuLabel = (fallbackLabel) => {
  const [display, setDisplay] = React.useState(() => urfuResolveAccountLabel(fallbackLabel));
  React.useEffect(() => {
    let cancelled = false;
    urfuLoadPreferredAccountLabel(fallbackLabel).then((value) => {
      if (!cancelled && value) {
        setDisplay(value);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [fallbackLabel]);
  return display;
};

const UrfuDesktopUserMenuToggle = ({ avatar, label }) => {
  const display = urfuUseAccountMenuLabel(label);
  return (
    <>
      <Avatar size="1.5em" src={avatar} alt="" className="mr-2" />
      <span data-hj-suppress>{display}</span>
      {' '}
      <Icon src={ExpandMore} size="sm" className="d-inline-block" aria-hidden focusable="false" />
    </>
  );
};

const UrfuLearningUserMenuToggle = ({ label, icon }) => {
  const display = urfuUseAccountMenuLabel(label);
  return (
    <>
      {icon ? (
        <FontAwesomeIcon icon={icon} className="d-md-none" size="lg" />
      ) : (
        <Icon src={Person} className="d-md-none" aria-hidden focusable="false" />
      )}
      <span data-hj-suppress className="d-none d-md-inline">{display}</span>
    </>
  );
};

const UrfuMobileUserMenuToggle = ({ avatar, label }) => {
  const display = urfuUseAccountMenuLabel(label);
  return (
    <Avatar size="1.5rem" src={avatar} alt={display} />
  );
};


const UrfuGradeTooltipStyles = () => {
  React.useEffect(() => {
    const fire = () => {
      window.dispatchEvent(new Event('resize'));
    };
    const frame = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(fire);
    });
    const timeouts = [0, 80, 200, 500].map((ms) => window.setTimeout(fire, ms));
    return () => {
      window.cancelAnimationFrame(frame);
      timeouts.forEach((id) => window.clearTimeout(id));
    };
  }, []);

  return (
    <style>
      {`
        #passing-grade-tooltip,
        #non-passing-grade-tooltip,
        #minimum-grade-tooltip {
          background: #ffffff !important;
          border: 1px solid #D1D5DB !important;
          filter: none !important;
          box-shadow: 0 1px 3px rgba(21, 55, 109, 0.12);
        }
        #passing-grade-tooltip .arrow::before,
        #passing-grade-tooltip .arrow::after,
        #non-passing-grade-tooltip .arrow::before,
        #non-passing-grade-tooltip .arrow::after,
        #minimum-grade-tooltip .arrow::before,
        #minimum-grade-tooltip .arrow::after {
          border-top-color: #ffffff !important;
          border-bottom-color: #ffffff !important;
        }
        #passing-grade-tooltip .popover-body,
        #passing-grade-tooltip .text-white,
        #passing-grade-tooltip .text-dark-700,
        #non-passing-grade-tooltip .popover-body,
        #non-passing-grade-tooltip .text-white,
        #non-passing-grade-tooltip .text-dark-700,
        #minimum-grade-tooltip .popover-body,
        #minimum-grade-tooltip .text-white,
        #minimum-grade-tooltip .text-dark-700 {
          color: #111827 !important;
        }
      `}
    </style>
  );
};



const hideRegisterFromLoggedOutItems = (widget) => {
  const items = widget.content && widget.content.items;
  if (Array.isArray(items)) {
    widget.content.items = items.filter((item) => {
      const href = String(item.href || item.url || item.destination || '').toLowerCase();
      return href.indexOf('register') === -1
        && href.indexOf('signup') === -1
        && href.indexOf('sign-up') === -1;
    });
  }
  return widget;
};



const urfuCourseEndCache = new Map();

const urfuCourseIdFromProps = (props) => (
  props.courseId
  || props.courseKey
  || props.id
  || (props.course && (props.course.id || props.course.key || props.course.courseId || props.course.course_id))
  || ''
);

const urfuEndFromProps = (props) => (
  props.end
  || props.endDate
  || (props.course && (props.course.end || props.course.endDate || props.course.end_date))
  || ''
);

const formatUrfuEnd = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const locale = (typeof navigator !== 'undefined' && navigator.language) || 'ru-RU';
  return `Окончание: ${date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })}`;
};

const UrfuCourseCardEnd = ({ courseId, endHint }) => {
  const [label, setLabel] = React.useState(formatUrfuEnd(endHint));
  useEffect(() => {
    const hinted = formatUrfuEnd(endHint);
    if (hinted) {
      setLabel(hinted);
      if (courseId) {
        urfuCourseEndCache.set(courseId, hinted);
      }
      return undefined;
    }
    if (!courseId) {
      return undefined;
    }
    if (urfuCourseEndCache.has(courseId)) {
      setLabel(urfuCourseEndCache.get(courseId));
      return undefined;
    }
    const lms = getConfig().LMS_BASE_URL;
    if (!lms) {
      return undefined;
    }
    let cancelled = false;
    fetch(`${lms}/urfu/api/v1/course-meta/?course=${encodeURIComponent(courseId)}`, {
      credentials: 'omit',
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((data) => {
        if (cancelled || !data.end) {
          return;
        }
        const text = formatUrfuEnd(data.end);
        if (!text) return;
        urfuCourseEndCache.set(courseId, text);
        setLabel(text);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [courseId, endHint]);
  if (!label) {
    return null;
  }
  return (
    <div className="urfu-card-end">{label}</div>
  );
};

const wrapUrfuCourseCard = (widget) => {
  const DefaultCard = widget.content;
  if (typeof DefaultCard !== 'function') {
    return widget;
  }
  widget.content = (props) => (
    <div className="urfu-catalog-course-card">
      <DefaultCard {...props} />
      <UrfuCourseCardEnd
        courseId={urfuCourseIdFromProps(props)}
        endHint={urfuEndFromProps(props)}
      />
    </div>
  );
  return widget;
};


  addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'indigo_footer',
            type: DIRECT_PLUGIN,
            priority: 1,
            RenderWidget: IndigoFooter,
        },
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'read_theme_cookie',
            type: DIRECT_PLUGIN,
            priority: 2,
            RenderWidget: AddDarkTheme,
        },
    },
]);
  addPlugins(config, 'logo_slot', [
    {
        op: PLUGIN_OPERATIONS.Hide,
        widgetId: 'default_contents',
    },
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'custom_logo',
            type: DIRECT_PLUGIN,
            RenderWidget: ThemedLogo,
        }
    }
]);if (config.pluginSlots && config.pluginSlots['logo_slot']) {
  config.pluginSlots['logo_slot'].keepDefault = false;

  const logoInsertPlugins =
    config.pluginSlots['logo_slot'].plugins.filter(plugin => plugin.op === 'insert' && plugin.widget?.id === 'custom_logo');

  if (logoInsertPlugins.length > 1) {
    let kept = false;
    config.pluginSlots['logo_slot'].plugins =
      config.pluginSlots['logo_slot'].plugins.filter(plugin => {
        if (plugin.op === 'insert' && plugin.widget?.id === 'custom_logo') {
          if (kept) return false;
          kept = true;
        }
        return true;
      });
  }
}

if (!config.pluginSlots) {
  config.pluginSlots = {};
}

['org.openedx.frontend.catalog.course_about_page.sidebar'].forEach((slotId) => {
  if (!config.pluginSlots[slotId]) {
    config.pluginSlots[slotId] = { plugins: [] };
  }
  config.pluginSlots[slotId].keepDefault = false;
});

if (config.pluginSlots && config.pluginSlots['org.openedx.frontend.layout.footer.v1']) {
  const footerInsertPlugins =
    config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins.filter(
      plugin => plugin.op === 'insert' && plugin.widget?.id === 'indigo_footer'
    );

  if (footerInsertPlugins.length > 1) {
    let kept = false;
    config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins =
      config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins.filter(plugin => {
        if (plugin.op === 'insert' && plugin.widget?.id === 'indigo_footer') {
          if (kept) return false;
          kept = true;
        }
        return true;
      });
  }
}

  return config;
}

export default setConfig;